module.exports = ".search-result {\n  border: 1px solid #ddd;\n  border-bottom: 1px solid #ccc;\n  padding: 5px 20px;\n  cursor: pointer; }\n  .search-result:hover {\n    background-color: #eee; }\n  quill-editor.form-control {\n  height: auto;\n  padding-bottom: 0; }\n  quill-editor.form-control p {\n    margin-bottom: 1rem; }\n  quill-editor.form-control .ql-video {\n    width: 600px;\n    height: 300px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/book/shared/book-form/book-form.component.scss
// module id = ./src/app/book/shared/book-form/book-form.component.scss
// module chunks = main